<template>
  <div class="ins-hold-details">
    <MoreTitle title="机构持股汇总" />
    <div class="section-item edge-padding section-margin">
      <VueEcharts :option="option" />
    </div>
    <div class="section-item edge-padding">
      <ColTable :data="insHoldData">
        <ColTableColumn prop="reportDate" label="报告期" :row-style="{ color: theme['--font-color-3'] }">
          <template slot-scope="{ row }">{{ $digitjs(row.reportDate).isNull() }}</template>
        </ColTableColumn>
        <ColTableColumn prop="total" label="持股家数(家)" :row-style="{ color: theme['--font-color-1'] }">
          <template slot-scope="{ row }">{{ $digitjs(row.total).isNull() }}</template>
        </ColTableColumn>
        <ColTableColumn prop="holdingNumber" label="持股总数(股)" :row-style="{ color: theme['--font-color-1'] }">
          <template slot-scope="{ row }">{{ $digitjs(row.holdingNumber).convert() }}</template>
        </ColTableColumn>
        <ColTableColumn prop label="持股市值(元)" :row-style="{ color: theme['--font-color-1'] }">
          <template>--</template>
        </ColTableColumn>
        <ColTableColumn prop="holdingRatio" label="占总股本比例(%)" :row-style="{ color: theme['--font-color-1'] }">
          <template slot-scope="{ row }">
            {{ $digitjs(row.holdingRatio).rounded() }}
            <i
              v-if="row.holdingRatioChange < 0"
              class="iconfont icon-xiangxiajiantoucuxiao"
              :style="{ color: theme['--down-color'] }"
            ></i>
            <i
              v-if="row.holdingRatioChange > 0"
              class="iconfont icon-xiangshangjiantoucuxiao"
              :style="{ color: theme['--up-color'] }"
            ></i>
          </template>
        </ColTableColumn>
        <ColTableColumn prop="holdingNumberChange" label="持仓变化(股)" :row-style="{ color: theme['--font-color-1'] }">
          <template slot-scope="{ row }">{{ $digitjs(row.holdingNumberChange).isNull() }}</template>
        </ColTableColumn>
      </ColTable>
    </div>
  </div>
</template>

<script>
import VueEcharts from '@/components/common/VueEcharts.vue'
export default {
  components: { VueEcharts },
  inject: ['theme'],
  data() {
    return {
      insHoldData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    maxmin() {
      const holdingRatioArr = this.insHoldData.map(({ holdingRatio }) => holdingRatio)
      const priceArr = this.insHoldData.map(({ price }) => price)
      const maxHoldingRatio = Math.max(...holdingRatioArr)
      const minHoldingRatio = 0
      const maxPrice = Math.max(...priceArr)
      const minPrice = Math.min(...priceArr)
      const intervalHoldingRatio = (maxHoldingRatio - minHoldingRatio) / 2
      const intervalPrice = (maxPrice - minPrice) / 2
      return {
        maxHoldingRatio,
        minHoldingRatio,
        intervalHoldingRatio,
        maxPrice,
        minPrice,
        intervalPrice
      }
    },
    option() {
      return {
        grid: {
          top: 40,
          bottom: 0,
          left: 0,
          right: 0,
          containLabel: true
        },
        legend: {
          left: 0,
          itemWidth: 8,
          itemHeight: 8
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: this.theme['--font-color-3']
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            max: this.maxmin.maxHoldingRatio,
            min: this.maxmin.minHoldingRatio,
            interval: this.maxmin.intervalHoldingRatio,
            splitLine: {
              lineStyle: {
                color: this.theme['--border-color-1']
              }
            },
            axisLabel: {
              color: '#FF9933',
              formatter: (value) => {
                return this.$digitjs(value).rounded(1)
              }
            }
          },
          {
            type: 'value',
            max: this.maxmin.maxPrice,
            min: this.maxmin.minPrice,
            interval: this.maxmin.intervalPrice,
            splitLine: {
              lineStyle: {
                color: this.theme['--border-color-1']
              }
            },
            axisLabel: {
              color: '#E54C4B'
            }
          }
        ],
        dataset: {
          source: this.insHoldData
        },
        series: [
          {
            name: this.$t('占总股本比例(%)'),
            type: 'bar',
            barWidth: 22,
            encode: {
              x: 'reportDate',
              y: 'holdingRatio'
            },
            itemStyle: {
              color: '#FF9933'
            }
          },
          {
            name: this.$t('股价(元)'),
            type: 'line',
            yAxisIndex: 1,
            encode: {
              x: 'reportDate',
              y: 'price'
            },
            itemStyle: {
              color: '#E54C4B'
            }
          }
        ]
      }
    }
  },
  created() {
    this.getInsHoldData()
  },
  methods: {
    async getInsHoldData() {
      const res = await this.$post(this.$api.f10.us + '/summary/inst-hold-statistics', {
        symbol: this.symbol,
        startDate: '1990-01-01'
      })

      this.insHoldData = res.data?.slice(0, 5) ?? []
    }
  }
}
</script>

<style lang="scss" scoped>
.ins-hold-details {
  .section-item {
    background: var(--bg-color-2);
  }
}
</style>
